// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"Content1Page_contentContainer__23adp"};